import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { Navbar } from "@/components/Navbar";
import { Hero } from "@/components/Hero";
import { InstagramStrip } from "@/components/InstagramStrip";
import { EditorialMarquee } from "@/components/EditorialMarquee";
import { ProductStrip } from "@/components/ProductStrip";
import { RecentlyViewed } from "@/components/RecentlyViewed";
import { CategoryTiles } from "@/components/CategoryTiles";
import { Manifesto } from "@/components/Manifesto";
import { SetsSections } from "@/components/SetsSections";
import { Footer } from "@/components/Footer";

export default function Home() {
  const [brands, setBrands] = useState([]);
  const [settings, setSettings] = useState(null);

  useEffect(() => {
    api.get("/brands").then((r) => setBrands(r.data)).catch(() => {});
    api.get("/settings").then((r) => setSettings(r.data)).catch(() => {});
  }, []);

  return (
    <main data-testid="home-page">
      <Navbar />
      <Hero banners={settings?.banners || []} />
      <EditorialMarquee items={settings?.marquee_items} />
      <InstagramStrip reels={settings?.instagram_reels} profile={settings?.instagram_profile} brands={brands} />
      <ProductStrip />
      <RecentlyViewed />
      <CategoryTiles />
      <SetsSections />
      <Manifesto />
      <Footer brands={brands} />
    </main>
  );
}
